import React, { useState } from 'react';
import Loading from 'components/Loading';
import NoMatch from 'containers/NoMatch';
import useUser from 'hooks/useUser';
import Page from 'components/Page';
import { Button, Card, Col, Descriptions, Row } from 'antd';
import Table from 'components/Table';
import PhoneNumber from 'components/PhoneNumber';
import { useMutation } from 'hooks/apollo';
import { gql } from '@apollo/client';
import EditUserProfile from './EditUserProfile';
import EnableMFA from './EnableMFA';

const DISABLE_MFA = gql`
  mutation($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      mfa
    }
  }
`;

const UserProfile = () => {
  const { user, loading } = useUser();
  const [editUser, setEditUser] = useState(false);
  const [enableMfa, setEnableMfa] = useState(false);
  const [disableMfa, { loading: disableMfaLoading }] = useMutation(DISABLE_MFA);

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <NoMatch />;
  }

  const accountColumns = [
    {
      title: 'Account',
      dataIndex: ['customer', 'name'],
    },
    {
      title: 'Roles',
      dataIndex: 'roles',
      render: (roles) => roles?.map((role) => role.name).join(', '),
    },
  ];

  const dataSourceColumns = [
    {
      title: 'Data source',
      dataIndex: ['dataSource', 'title'],
    },
    {
      title: 'Roles',
      dataIndex: 'roles',
      render: (roles) => roles?.map((role) => role.name).join(', '),
    },
  ];

  const accountAccess = user?.customerAccess.filter((ca) => ca.roles.length > 0);
  const dataSourceAccess = accountAccess.flatMap((customerAccess) => customerAccess.dataSourceAccess.filter((wa) => wa.roles.length > 0));

  return (
    <Page>
      <Page.Header title="User profile" extra={<Button type="primary" onClick={() => setEditUser(true)}>Edit profile</Button>} />
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Descriptions column={1}>
                  <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>
                  <Descriptions.Item label="First name">{user?.firstname}</Descriptions.Item>
                  <Descriptions.Item label="Last name">{user?.lastname}</Descriptions.Item>
                </Descriptions>
              </Col>
              <Col span={12}>
                <Descriptions column={1}>
                  <Descriptions.Item label="Phone"><PhoneNumber number={user?.phone} /></Descriptions.Item>
                  <Descriptions.Item label="Multi factor authentication">
                    {user?.mfa || 'Disabled'}
                  </Descriptions.Item>
                </Descriptions>
                {!user?.mfa && !user?.phone && <Button onClick={() => setEditUser(true)}>Add a phone number to enable SMS verification</Button>}
                {!user?.mfa && user?.phone && <Button onClick={() => setEnableMfa(true)}>Enable SMS verification</Button>}
                {user?.mfa && <Button onClick={() => disableMfa({ variables: { input: { id: user.id, mfa: null } } })} loading={disableMfaLoading}>Disable SMS verification</Button>}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24}>
          <Page.Header title="Accounts" />
          <Card>
            <Table dataSource={accountAccess} columns={accountColumns} />
          </Card>
        </Col>
        <Col span={24}>
          <Page.Header title="Data sources" />
          <Card>
            <Table dataSource={dataSourceAccess} columns={dataSourceColumns} />
          </Card>
        </Col>
      </Row>
      <EditUserProfile user={editUser && user} onCancel={() => setEditUser(false)} />
      <EnableMFA user={enableMfa && user} onCancel={() => setEnableMfa(false)} />
    </Page>
  );
};

export default UserProfile;
